const STORAGE_PREFIX = 'fundgenius_client_drafts_v1';

function storageKey(agencyId) {
  return `${STORAGE_PREFIX}:${agencyId || 'unknown'}`;
}

function safeParse(raw) {
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function listFundingClientDrafts(agencyId) {
  if (!agencyId || typeof window === 'undefined') return [];
  const drafts = safeParse(window.localStorage.getItem(storageKey(agencyId)));
  return drafts
    .slice()
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
}

export function saveFundingClientDraft(agencyId, { form, source = 'Manual intake', draftId, name } = {}) {
  if (!agencyId || typeof window === 'undefined') {
    throw new Error('Agency is required to save a client draft.');
  }
  const now = new Date().toISOString();
  const drafts = listFundingClientDrafts(agencyId);
  const id = draftId || `draft_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
  const next = {
    id,
    agencyId,
    name: name?.trim() || buildDraftName(form),
    source,
    form: { ...form },
    updatedAt: now,
    createdAt: drafts.find((item) => item.id === id)?.createdAt || now,
  };
  const without = drafts.filter((item) => item.id !== id);
  window.localStorage.setItem(storageKey(agencyId), JSON.stringify([next, ...without]));
  return next;
}

export function deleteFundingClientDraft(agencyId, draftId) {
  if (!agencyId || !draftId || typeof window === 'undefined') return;
  const drafts = listFundingClientDrafts(agencyId).filter((item) => item.id !== draftId);
  window.localStorage.setItem(storageKey(agencyId), JSON.stringify(drafts));
}

export function clearFundingClientDrafts(agencyId) {
  if (!agencyId || typeof window === 'undefined') return;
  window.localStorage.removeItem(storageKey(agencyId));
}

import { buildContactFullName } from '../../utils/fundingClientIntakeUtils';

function buildDraftName(form = {}) {
  const fullName = buildContactFullName(form);
  if (fullName) return fullName;
  if (form.businessLegalName?.trim()) return form.businessLegalName.trim();
  return 'Untitled client draft';
}

export function formatDraftSourceLabel(source) {
  const normalized = String(source || '').toLowerCase();
  if (normalized.includes('paste')) return 'Paste';
  if (normalized.includes('upload') || normalized.includes('document')) return 'Upload';
  if (normalized.includes('bulk')) return 'Bulk import';
  return 'Manual intake';
}
